export const DEFAULT_DATE_MASK = 'dd/MM/yyyy'
export const MIN_YEAR = 1000
export const MAX_YEAR = 9999

export const DATE_PICKER_HORIZONTAL_OFFSET = -16

export const DATE_PICKER_VERTICAL_OFFSET = -16

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
